import React, { useState, useMemo, useContext, useEffect } from 'react'
import styles from './AssignClients.module.css'
import { executivesData, getExecutiveFullName } from '../../store/ExecutiveContext';
import { BASE_URL_API } from '../../References/urls'
import AuthContext from '../../store/auth-context'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'

const AssignClients = () => {
    const authCtx = useContext(AuthContext)
    const [searchTerm, setSearchTerm] = useState('')
    const [selectedExecutive, setSelectedExecutive] = useState('all')
    const [selectedClients, setSelectedClients] = useState([])
    const [assignExecutive, setAssignExecutive] = useState('')
    const [createdByFilter, setCreatedByFilter] = useState('')
    const [clients, setClients] = useState([
        { id: 1, name: 'Glamour Salon', location: 'Mumbai', status: 'Active', assignedTo: 1, lastContact: '2 days ago', revenue: '₹45,000' },
        { id: 2, name: 'Style Studio', location: 'Delhi', status: 'Active', assignedTo: 1, lastContact: '1 week ago', revenue: '₹32,000' },
        { id: 3, name: 'Beauty Lounge', location: 'Bangalore', status: 'Pending', assignedTo: null, lastContact: 'Never', revenue: '₹0' },
        { id: 4, name: 'Hair & Beyond', location: 'Pune', status: 'Active', assignedTo: 2, lastContact: '3 days ago', revenue: '₹28,500' },
        { id: 5, name: 'Radiance Spa', location: 'Hyderabad', status: 'Active', assignedTo: 3, lastContact: '5 days ago', revenue: '₹52,000' },
        { id: 6, name: 'Elite Cuts', location: 'Chennai', status: 'Pending', assignedTo: null, lastContact: 'Never', revenue: '₹0' },
        { id: 7, name: 'Trendy Hair', location: 'Kolkata', status: 'Active', assignedTo: 4, lastContact: '1 day ago', revenue: '₹38,000' },
        { id: 8, name: 'Glow Beauty', location: 'Ahmedabad', status: 'Inactive', assignedTo: 5, lastContact: '2 months ago', revenue: '₹15,000' },
    ])
    const [assignmentStats, setAssignmentStats] = useState([])

    const colors = [
        '#6366f1',
        '#8b5cf6',
        '#ec4899',
        '#06b6d4',
        '#10b981',
    ];

    // pick a random color
    const getRandomColor = () => {
        const randomColor = colors[Math.floor(Math.random() * colors.length)];
        return randomColor
    }


    const getExecutiveAvatar = (firstName, lastName = "") => {
        const firstLetter = firstName?.substring(0, 1)
        const secondLetter = lastName?.substring(0, 1)
        const avatar = firstLetter + secondLetter
        return avatar
    }

    const filteredClients = useMemo(() => {
        return clients.filter(client => {
            const search = searchTerm?.toLowerCase() ?? ''

            const matchesSearch =
                client?.storeName?.toLowerCase().includes(search) ||
                client?.storeAddress?.toLowerCase().includes(search)

            const matchesExecutive =
                selectedExecutive === 'all' ||
                (selectedExecutive === 'unassigned'
                    ? !client?.assignedTo
                    : client?.assignedTo === selectedExecutive)

            const matchesCreatedBy =
                !createdByFilter || client?.onboardedBy === createdByFilter

            return matchesSearch && matchesExecutive && matchesCreatedBy
        })
    }, [searchTerm, selectedExecutive, createdByFilter, clients])


    const handleSelectClient = (clientId) => {
        setSelectedClients(prev =>
            prev.includes(clientId)
                ? prev.filter(id => id !== clientId)
                : [...prev, clientId]
        )
    }

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedClients(filteredClients.map(c => c.storeIdentifier))
        } else {
            setSelectedClients([])
        }
    }

    const handleAssign = async () => {
        if (assignExecutive && selectedClients.length > 0) {
            // Implement assignment logic here
            console.log(`Assigning clients ${selectedClients} to executive ${assignExecutive}`)
            console.log(selectedClients)
            const response = await fetch(BASE_URL_API + "/assignStoresToExecutive",
                {
                    method: "POST",
                    body: JSON.stringify({
                        token: authCtx.token,
                        assignTo: assignExecutive,
                        storeIdentifiers: selectedClients,
                        assignBy: authCtx.userIdentifier
                    })
                }
            )

            if (!response.ok) {
                console.log("Something went wrong : Server Error")
            } else {
                const respo = await response.json()
                if (respo.status === "success") {
                    getStoreForAssignment()
                    toast(`Successfully assigned stores!`)
                } else {

                }
                console.log(respo)
            }




            setSelectedClients([])
            setAssignExecutive('')
        }
    }

    const getStatusBadge = (status) => {
        const statusConfig = {
            'Active': { color: '#10b981', bg: '#d1fae5' },
            'Pending': { color: '#f59e0b', bg: '#fef3c7' },
            'Inactive': { color: '#6b7280', bg: '#f3f4f6' }
        }
        return statusConfig[status] || statusConfig.Pending
    }

    const getStoreForAssignment = async () => {
        const response = await fetch(BASE_URL_API + "/getStoreForAssignment",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    executiveIdentifier: authCtx?.userIdentifier
                })
            }
        )

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo.status === "success") {
                setClients(respo?.response)
                setAssignmentStats(respo?.assignmentStats)
            } else {
                setClients([])
            }
            console.log(respo)
        }


    }


    useEffect(() => {
        getStoreForAssignment()
    }, [])


    return (
        <div className={styles.mainWrapper}>
            <div className={styles.mainHeaderWrapper}>
                <div className={styles.headerLeft}>
                    <h1 className={styles.pageTitle}>Client Assignment</h1>
                    <p className={styles.pageSubtitle}>{filteredClients.length} clients · {selectedClients.length} selected</p>
                </div>
                <div className={styles.headerRight}>
                    <button className={styles.btnSecondary}>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M14 9v2a2 2 0 01-2 2H4a2 2 0 01-2-2V9m11-4L8 10m0 0L3 5m5 5V1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        Export
                    </button>
                    <button className={styles.btnPrimary}>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M8 3v10m5-5H3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                        </svg>
                        Add Client
                    </button>
                </div>
            </div>

            <div className={styles.mainBodyWrapper}>
                {/* Executive Cards */}
                <div className={styles.executiveSection}>
                    <div className={styles.sectionHeader}>
                        <h2 className={styles.sectionTitle}>Alloted Members</h2>
                    </div>
                    <div className={styles.executiveGrid}>
                        {assignmentStats.map(exec => (
                            <div key={exec.id} className={styles.executiveCard}>
                                <div className={styles.executiveAvatar} style={{ backgroundColor: getRandomColor() }}>
                                    {getExecutiveAvatar(getExecutiveFullName(exec?.assignedTo))}
                                </div>
                                <div className={styles.executiveInfo}>
                                    <h3 className={styles.executiveName}>{getExecutiveFullName(exec?.assignedTo)}</h3>
                                    <p className={styles.executiveRole}>Total Jobs : {exec.totalJobs}</p>
                                </div>
                                <div className={styles.executiveStats}>
                                    <span className={styles.clientCount}>{exec.totalStores}</span>
                                    <span className={styles.clientLabel}>Stores</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Filters & Actions */}
                <div className={styles.controlBar}>
                    <div className={styles.searchWrapper}>
                        <svg className={styles.searchIcon} width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M7 12A5 5 0 107 2a5 5 0 000 10zM14 14l-3-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                        </svg>
                        <input
                            type="text"
                            placeholder="Search clients..."
                            className={styles.searchInput}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>

                    <select
                        className={styles.filterSelect}
                        value={createdByFilter}
                        onChange={(e) => setCreatedByFilter(e.target.value)}
                    >
                        <option value="">Select Created By</option>
                        {executivesData.map(exec => (
                            <option key={exec.userID} value={exec.userID}>{`${exec.firstName} ${exec.lastName}`}</option>
                        ))}
                    </select>
                    
                    <select
                        className={styles.filterSelect}
                        value={selectedExecutive}
                        onChange={(e) => setSelectedExecutive(e.target.value)}
                    >
                        <option value="">Select Assigned To</option>
                        <option value="unassigned">Unassigned</option>
                        {executivesData.map(exec => (
                            <option key={exec.userID} value={exec.userID}>{`${exec.firstName} ${exec.lastName}`}</option>
                        ))}
                    </select>


                    {selectedClients.length > 0 && (
                        <div className={styles.bulkActions}>
                            <select
                                className={styles.assignSelect}
                                value={assignExecutive}
                                onChange={(e) => setAssignExecutive(e.target.value)}
                            >
                                <option value="">Assign to...</option>
                                {executivesData.map(exec => (
                                    <option key={exec.userID} value={exec.userID}>{`${exec.firstName} ${exec.lastName}`}</option>
                                ))}
                            </select>
                            <button
                                className={styles.btnAssign}
                                onClick={handleAssign}
                                disabled={!assignExecutive}
                            >
                                Assign ({selectedClients.length})
                            </button>
                        </div>
                    )}
                </div>

                {/* Clients Table */}
                <div className={styles.tableWrapper}>
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th className={styles.thCheckbox}>
                                    <input
                                        type="checkbox"
                                        className={styles.checkbox}
                                        onChange={handleSelectAll}
                                        checked={selectedClients.length === filteredClients.length && filteredClients.length > 0}
                                    />
                                </th>
                                <th className={styles.th}>Client Name & Location</th>
                                <th className={styles.th}>City</th>
                                <th className={styles.th}>Status</th>
                                <th className={styles.th}>Assigned To</th>
                                <th className={styles.th}>Last Job</th>
                                <th className={styles.th}>Total Jobs</th>
                                <th className={styles.th}>Onboarded By</th>
                                <th className={styles.thActions}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredClients.map(client => {
                                const statusStyle = getStatusBadge(client.isPaidHiring === "1" ? "Active" : "Pending")
                                return (
                                    <tr key={client.storeIdentifier} className={selectedClients.includes(client.storeIdentifier) ? styles.selectedRow : ''}>
                                        <td className={styles.tdCheckbox}>
                                            <input
                                                type="checkbox"
                                                className={styles.checkbox}
                                                checked={selectedClients.includes(client.storeIdentifier)}
                                                onChange={() => handleSelectClient(client.storeIdentifier)}
                                            />
                                        </td>
                                        <td className={styles.td}>
                                            <div className={styles.clientName}>{client.storeName?.substring(0, 40)}{client?.storeName?.length > 40 && "..."} </div>
                                            <div className={styles.storeCity}>{client.storeAddress?.substring(0, 60)}{client?.storeAddress?.length > 60 && "..."} </div>
                                        </td>
                                        <td className={styles.td}>
                                            <span className={styles.location}>{client.storeCity}</span>
                                        </td>
                                        <td className={styles.td}>
                                            <span
                                                className={styles.statusBadge}
                                                style={{
                                                    color: statusStyle.color,
                                                    backgroundColor: statusStyle.bg
                                                }}
                                            >
                                                {client.isPaidHiring === "1" ? "Paid" : "Un-paid"}
                                            </span>
                                        </td>
                                        <td className={styles.td}>
                                            <div className={styles.assignedUser}>
                                                {client.assignedTo ? (
                                                    <>
                                                        <div
                                                            className={styles.miniAvatar}
                                                            style={{ backgroundColor: getRandomColor() }}
                                                        >
                                                            {getExecutiveAvatar(getExecutiveFullName(client?.assignedTo))}
                                                        </div>
                                                        <span>{getExecutiveFullName(client.assignedTo)}</span>
                                                    </>
                                                ) : (
                                                    <span className={styles.unassigned}>Unassigned</span>
                                                )}
                                            </div>
                                        </td>
                                        <td className={styles.td}>
                                            <span className={styles.lastContact}>{client?.lastJobCreatedOn}</span>
                                        </td>
                                        <td className={styles.td}>
                                            <span className={styles.revenue}>{client?.totalJobs}</span>
                                        </td>
                                        <th className={styles.td}>
                                            <span className={styles.lastContact}>
                                                {getExecutiveFullName(client?.onboardedBy)}
                                            </span>
                                        </th>
                                        <td className={styles.tdActions}>
                                            <button className={styles.actionBtn} title="Edit">
                                                <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                                                    <path d="M11.333 2A1.886 1.886 0 0114 4.667l-9 9-3.667 1 1-3.667 9-9z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </button>
                                            <Link to={`/manage-stores/${client?.storeIdentifier}`} className={styles.actionBtn} title="View Details">
                                                <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                                                    <path d="M1 8s3-5 7-5 7 5 7 5-3 5-7 5-7-5-7-5z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.5" />
                                                </svg>
                                            </Link >
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>

                    {filteredClients.length === 0 && (
                        <div className={styles.emptyState}>
                            <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                                <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <h3>No clients found</h3>
                            <p>Try adjusting your search or filters</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default AssignClients